{
  "#PRUEFPROTOKOLL": {
    "TITLE": "Prüfprotokoll",
    "PAGES": {
      "LIST": {
        "SUBTITLE": "Ergebnisse",
        "TABLE": {
          "HEADER_ANWENDER": "Anwender",
          "HEADER_LAGERPLATZ": "Lagerplatz",
          "HEADER_AKTIVITAET": "Aktivität",
          "HEADER_ZEITSTEMPEL": "Zeitstempel"
        }
      },
      "ABFRAGE":{
        "SUBTITLE": "Abfrage",
        "LAGERPLATZ": "Lagerplatz",
        "AKTIVITAET": "Aktivität",
        "VONDATUM": "Von-Datum",
        "BISDATUM": "Bis-Datum"
      },
      "ERSTELLEN_KONTROLLE":{
        "SUBTITLE": "Abfrage",
        "SECTION_HEADER_ZUSAMMENFASSUNG": "Zusammenfassung",
        "SECTION_HEADER_BEMERKUNG": "Bemerkung",
        "SECTION_LABEL_LAGERPLATZ": "Lagerplatz",
        "SECTION_LABEL_AKTIVITAET": "Lagerplatz",
        "PLACEHOLDER_BEMERKUNG": "Bemerkung/Kommentar hinzufügen",
        "AKTIVITAET": "Aktivität",
        "VONDATUM": "Von-Datum",
        "BISDATUM": "Bis-Datum"
      }
    },
    "STEPS": {
      "STEP_01": {
        "HEADER": "Lagerplatz",
        "SUBHEADER": "Hygienemittel scannen oder alternativ über das Eingabefeld auswählen"
      },
      "STEP_02": {
        "HEADER": "Aktivität",
        "SUBHEADER": "Durchgeführte Aktivität auswähle"
      },
      "STEP_03": {
        "HEADER": "Kontrolle",
        "SUBHEADER": "Bemerkung hinzufügen und Auswahl kontrollieren"
      }
    }
  }
}
